module.exports = __webpack_public_path__ + "static/media/hanske.c6916b12.jpg";